import { BecomePatron } from "./styles";
import becomePatron_img from "src/assets/img/svg/becomePatron.svg";

// import React, { useEffect } from 'react';

// const BecomePatreonFunder = () => {
  
//   useEffect(() => {
//     const script = document.createElement('script');
//     script.src = "https://c6.patreon.com/becomePatronButton.bundle.js";
//     script.async = true;
//     document.body.appendChild(script);
// return () => {  
//       document.body.removeChild(script);
//     }
//   });
// };
// export default BecomePatreonFunder;

// Create the function
// export function BecomePatreonFunder() {
//   const script = document.createElement('script');
//   script.src = "https://c6.patreon.com/becomePatronButton.bundle.js";;
//   script.async = true;
//   document.body.appendChild(script);
// }

const PATRON_URL = "https://www.patreon.com/CosmicSuccubusEvolution";

const BecomePatreonFunder = () => {
  return (
    <BecomePatron href={PATRON_URL} target="_blank" rel="noopener noreferrer">
      <img
        src={becomePatron_img}
        width="220"
        draggable="false"
        decoding="async"
        loading="lazy"
        alt="Join as a Patron"
      />
    </BecomePatron>
  );
};

export default BecomePatreonFunder;